// Matches `app/models/concerns/featurable.rb`

export const FEATURABLE_DISABLED = 'disabled';
export const FEATURABLE_PRIVATE = 'private';
export const FEATURABLE_ENABLED = 'enabled';
export const FEATURABLE_PUBLIC = 'public';
